module.exports = __webpack_public_path__ + "img/ic-coupon-prestige.svg";